/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable max-len */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/anchor-is-valid */
import 'react-toastify/dist/ReactToastify.css';

import { Loading } from '@brands/Components/LoadingSpinner/Loading';
import TextField from '@brands/Components/Inputs/MuiTextField/TextField';
import Sidenav from '@brands/Dashboard/Sidenav/Sidenav';
import { getUserByHash } from '@brands/services/auth/getUserByHash';
import { login, LoginResponse } from '@brands/services/auth/login';
import { authenticatePasskey } from '@brands/services/auth/webauthn';
import { isStartableCaseType } from '@brands/services/cases/retiredCaseTypes';
import { setUser } from '@brands/store/slices/authSlice';
import { setOrganizationPrices } from '@brands/store/slices/organizationPricingSlice';
import { setOrganization } from '@brands/store/slices/organizationSlice';
import { setShowVideoThumbnail } from '@brands/store/slices/showVideoThumbnailSlice';
import { yupResolver } from '@hookform/resolvers/yup';
import { browserSupportsWebAuthn } from '@simplewebauthn/browser';
import Cookies from 'js-cookie';
import queryString from 'query-string';
import React, { createContext, FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import Button from '../../Components/Button/Button';
import { config } from '../../config/config';
import { useClientBrandingFromUrl } from '../../hooks/useClientBrandingFromUrl';
import { InviteModalPayload, usePostAuth } from '../../hooks/usePostAuth';
import { useAppDispatch } from '../../hooks/useReduxHook';
import { confirmEmailUpdate } from '../../services/auth/confirmEmailUpdate';
import { resolveInvite } from '../../services/patient_plan/services';
import { displayErrorDetails, ErrorType } from '../../Utils/displayError';
import { cookieOptions } from '../../Utils/getToken';
import { isValidPhoneNumber } from '../../Utils/validation';
import { INVITE_TOKEN_KEY, inviteReasonToHuman, normalizeUsername } from '../assets/helpers';
import ConfirmOTP from '../ConfirmOTP/ConfirmOTP';
import ForgotPasswordModalConfirmation from '../ForgotPasswordModals/ForgotPasswordModalConfirmation';
import ForgotPasswordModalStepOne from '../ForgotPasswordModals/ForgotPasswordModalStepOne';
import ForgotPasswordModalStepThree from '../ForgotPasswordModals/ForgotPasswordModalStepThree';
import ForgotPasswordModalStepTwo from '../ForgotPasswordModals/ForgotPasswordModalStepTwo';
import MultiFactorAuthentication from '../MultiFactorAuthentication/MultiFactorAuthentication';
import UpdateEmailModalStepOne from '../UpdateEmail/UpdateEmailModalStepOne';
import UpdateEmailModalStepThree from '../UpdateEmail/UpdateEmailModalStepThree';
import UpdateEmailModalStepTwo from '../UpdateEmail/UpdateEmailModalStepTwo';
import styles from './styles.module.scss';
import { getResetPasswordHashFromUrl } from './utils/resetPasswordLink';
import { validationSchema } from './utils/validationSchema';

type UserSubmitForm = {
  email: string;
  password: string;
};

type ForgotPasswordCredentials = {
  username?: string;
  code: string;
  new_password: string;
  password?: string;
  reset_password_hash?: string;
  last_four_digits?: string;
};

export const JWTContext = createContext('');

const PLAN_ROUTE = '/Patient/my-plan';

const SignIn: FC = () => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const { clientCode } = useParams<{ clientCode: string }>();
  useClientBrandingFromUrl(clientCode);
  const { triggerPostAuth } = usePostAuth();

  const phoneCaptureRef = useRef<string>('');
  const mountedRef = useRef(true);
  const inviteEffectRanRef = useRef(false);

  const queryParams = useMemo(() => queryString.parse(location.search), [location.search]);

  const [forgotPasswordStep, setForgotPasswordStep] = useState(0);
  const [updateEmailStep, setUpdateEmailStep] = useState(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [resetFlag, setResetFlag] = useState<boolean>(false);
  const [otpModal, setOtpModal] = useState(false);
  const [credentials, setCredentials] = useState<ForgotPasswordCredentials>({
    username: '',
    code: '',
    new_password: '',
    last_four_digits: '',
  });
  const [showTwoFactorAuth, setShowTwoFactorAuth] = useState<{
    trigger: boolean;
    response: LoginResponse | null;
  }>({ trigger: false, response: null });

  const [inviteResult, setInviteResult] = useState<InviteModalPayload | null>(null);

  const [urlChecked, setUrlChecked] = useState(false);

  const emailConfirmationHandled = useRef(false);
  const navigate = useNavigate();

  // Normalize the old ?client= querystring convention onto the path-based
  // /{clientCode} URL, so existing bookmarked/shared links keep working.
  useEffect(() => {
    if (clientCode) return;
    const clientFromQuery = searchParams.get('client');
    if (!clientFromQuery) return;

    const params = new URLSearchParams(searchParams);
    params.delete('client');
    navigate(`/${clientFromQuery}${params.toString() ? `?${params.toString()}` : ''}`, { replace: true });
  }, [clientCode, searchParams, navigate]);

  useEffect(() => {
    const emailParam = searchParams.get('email');

    if (emailParam) {
      const correctedEmail = emailParam.trim().replace(/\s/g, '+');

      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const emailValid = emailRegex.test(correctedEmail);
      if (emailValid) {
        setValue('email', correctedEmail);
        setCredentials({ username: correctedEmail });
      }
    }
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const setSafeLoading = useCallback((v: boolean) => {
    if (mountedRef.current) setLoading(v);
  }, []);

  const intakeIntent = useMemo(() => {
    const raw = queryParams.start_case;
    // Only honor a `start_case` naming a case type patients can still start:
    // arbitrary URL values never reach sessionStorage or the intake form, and
    // neither do retired types that are technically still in the enum.
    const caseType = isStartableCaseType(raw) ? raw : null;

    if (!caseType) return null;

    return {
      caseType,
      source: 'marketing',
    };
  }, [queryParams]);

  useEffect(() => {
    if (intakeIntent) {
      sessionStorage.setItem('intakeIntent', JSON.stringify(intakeIntent));
    }
  }, [intakeIntent]);

  const hardSignOut = (): void => {
    try {
      Cookies.remove('jwtToken', cookieOptions());
      Cookies.remove('refreshToken', cookieOptions());
      Cookies.remove('jwtTokenExpire', cookieOptions());
    } catch {
      /* noop */
    }
    try {
      localStorage.removeItem('isAuthenticated');
      sessionStorage.removeItem('isAuthenticated');
    } catch {
      /* noop */
    }
    dispatch(setUser({ userInfo: null }));
    dispatch(setShowVideoThumbnail(false));
    dispatch(setOrganization({ currentOrganization: null }));
    dispatch(setOrganizationPrices({ currentOrganizationPrices: null }));
  };

  const initialize = (): void => {
    try {
      const authSuspend = sessionStorage.getItem('authSuspend') === '1';
      if (authSuspend) {
        const raw = sessionStorage.getItem('inviteResult');
        if (raw) {
          try {
            const parsed: InviteModalPayload = JSON.parse(raw);
            setInviteResult(parsed);
          } catch {
            // ignore parse failure
          }
        }
      }
    } catch (error: unknown) {
      displayErrorDetails(error);
    }
    dispatch(setUser({ userInfo: null }));
    dispatch(setShowVideoThumbnail(false));
    dispatch(setOrganization({ currentOrganization: null }));
    dispatch(setOrganizationPrices({ currentOrganizationPrices: null }));
  };

  useEffect(() => {
    (async (): Promise<void> => {
      // Prevent StrictMode double-run in dev
      if (inviteEffectRanRef.current) return;
      inviteEffectRanRef.current = true;

      const rawHref = typeof window !== 'undefined' ? window.location.href : '';
      const params = new URLSearchParams(typeof window !== 'undefined' ? window.location.search : '');

      if (params.get('invite')) {
        const token = params.get('invite') as string;
        localStorage.setItem(INVITE_TOKEN_KEY, token);

        try {
          const meta = await resolveInvite(token);
          const infoSeenKey = `invite_toast_seen:${token}`;
          const errSeenKey = `invite_error_seen:${token}`;

          if (meta?.ok) {
            if (!sessionStorage.getItem(infoSeenKey)) {
              toast.info('You’re almost there—log in or sign up to join this plan.');
              sessionStorage.setItem(infoSeenKey, '1');
            }
          } else {
            // Guard the error toast to avoid duplicates
            if (!sessionStorage.getItem(errSeenKey)) {
              toast.error(inviteReasonToHuman(meta?.reason));
              sessionStorage.setItem(errSeenKey, '1');
            }
            localStorage.removeItem(INVITE_TOKEN_KEY);
          }
        } catch {
          // Guard the generic invalid/expired toast too
          const invalidSeenKey = `invite_invalid_seen:${token}`;
          if (!sessionStorage.getItem(invalidSeenKey)) {
            toast.error('This invite link is invalid or expired.');
            sessionStorage.setItem(invalidSeenKey, '1');
          }
          localStorage.removeItem(INVITE_TOKEN_KEY);
        }

        try {
          const url = new URL(rawHref);
          url.searchParams.delete('invite');
          window.history.replaceState({}, '', url.toString());
        } catch {
          /* noop */
        }
      } else {
        localStorage.removeItem(INVITE_TOKEN_KEY);
      }

      const resetPasswordHash = getResetPasswordHashFromUrl();

      if (resetPasswordHash) {
        try {
          await getUserByHash(resetPasswordHash);
          setResetFlag(true);
          setForgotPasswordStep(3);
          setCredentials({
            reset_password_hash: resetPasswordHash,
            code: '',
            new_password: '',
            password: '',
          });
        } catch (error) {
          displayErrorDetails(error);
        } finally {
          setUrlChecked(true);
        }
      }

      if (params.get('update_email_token') && !emailConfirmationHandled.current) {
        emailConfirmationHandled.current = true;
        try {
          await confirmEmailUpdate(params.get('update_email_token') as string);
          try {
            const url = new URL(rawHref);
            url.searchParams.delete('update_email_token');
            window.history.replaceState({}, '', url.toString());
          } catch {
            /* noop */
          }
          toast.success('Email updated successfully! Please log in with your new email.');
        } catch (error) {
          displayErrorDetails(error);
        } finally {
          setUrlChecked(true);
        }
      }
      setUrlChecked(true);
    })();
  }, []);

  useEffect(() => {
    initialize();
    localStorage.removeItem('sign-up-form');
  }, []);

  const renderForgotPasswordModal = (): JSX.Element | null => {
    switch (forgotPasswordStep) {
      case 1:
        return (
          <ForgotPasswordModalStepOne
            forgotPasswordStep={forgotPasswordStep}
            setForgotPasswordStep={setForgotPasswordStep}
            setUpdateEmailStep={setUpdateEmailStep}
            credentials={credentials}
            setCredentials={setCredentials}
          />
        );
      case 2:
        return (
          <ForgotPasswordModalStepTwo
            forgotPasswordStep={forgotPasswordStep}
            setForgotPasswordStep={setForgotPasswordStep}
            credentials={credentials}
            setCredentials={setCredentials}
            resetFlag={resetFlag}
          />
        );
      case 3:
        return (
          <ForgotPasswordModalStepThree
            forgotPasswordStep={forgotPasswordStep}
            setForgotPasswordStep={setForgotPasswordStep}
            credentials={credentials}
            setCredentials={setCredentials}
            resetFlag={resetFlag}
            triggerLogin={triggerLogin}
          />
        );
      case 5:
        return (
          <ForgotPasswordModalConfirmation
            forgotPasswordStep={forgotPasswordStep}
            setForgotPasswordStep={setForgotPasswordStep}
            credentials={credentials}
            setCredentials={setCredentials}
          />
        );
      default:
        return null;
    }
  };

  const renderUpdateEmailModal = (): JSX.Element | null => {
    switch (updateEmailStep) {
      case 1:
        return (
          <UpdateEmailModalStepOne
            setUpdateEmailStep={setUpdateEmailStep}
            updateEmailStep={updateEmailStep}
            setCredentials={setCredentials}
          />
        );
      case 2:
        return (
          <UpdateEmailModalStepTwo
            updateEmailStep={updateEmailStep}
            setUpdateEmailStep={setUpdateEmailStep}
            credentials={credentials}
            setCredentials={setCredentials}
          />
        );
      case 3:
        return (
          <UpdateEmailModalStepThree
            setUpdateEmailStep={setUpdateEmailStep}
            updateEmailStep={updateEmailStep}
            credentials={credentials}
            setCredentials={setCredentials}
          />
        );
      default:
        return null;
    }
  };

  const onConfirmedOTP = (): void => {
    setOtpModal(false);
    setSafeLoading(false);
  };

  const showJoinedToast = (): void => {
    const toastId = toast.success(
      <div style={{ display: 'flex', alignItems: 'flex-start' }}>
        <div style={{ fontSize: 14, color: '#1E4620' }}>
          <span>You’ve successfully joined the plan.</span>
          <button
            type="button"
            onClick={() => {
              navigate(PLAN_ROUTE);
              if (toastId !== undefined) toast.dismiss(toastId);
            }}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              textDecoration: 'underline',
              cursor: 'pointer',
              paddingLeft: '5px',
              color: '#1E4620',
            }}
          >
            View plan.
          </button>
        </div>
      </div>,
      { closeOnClick: false, autoClose: 6000 },
    );
  };

  const triggerLogin = async (response: LoginResponse): Promise<void> => {
    await triggerPostAuth(response, {
      event: 'login',
      suspendNavigationIfInvite: true,
      onInviteResult: (payload) => {
        if (payload.status === 'JOINED') {
          sessionStorage.removeItem('authSuspend');
          sessionStorage.removeItem('inviteResult');
          showJoinedToast();
          return;
        }
        setInviteResult(payload);
        sessionStorage.setItem('authSuspend', '1');
        sessionStorage.setItem('inviteResult', JSON.stringify(payload));
      },
    });
  };

  const onPasskeySignIn = async (): Promise<void> => {
    try {
      const response = await authenticatePasskey();
      await triggerLogin(response);
    } catch (err) {
      if (err instanceof Error && err.name === 'NotAllowedError') return;
      displayErrorDetails(err);
    }
  };

  const endLogin = (data: UserSubmitForm, error: unknown): void => {
    setSafeLoading(false);
    if (error as ErrorType) {
      const { response } = error as ErrorType;

      if (response?.data?.message?.includes('Password reset is required')) {
        setResetFlag(true);
        setCredentials({
          ...credentials,
          username: isValidPhoneNumber(phoneCaptureRef.current)
            ? `+1${phoneCaptureRef.current}`
            : data.email.toLowerCase(),
        });
        setForgotPasswordStep(1);
        return;
      }

      if (response?.data?.message?.includes('Invalid credential')) {
        setError('password', {
          type: 'manual',
          message:
            'Invalid password. Please try again. If the problem persists, please try resetting your password by selecting “Forgot Password?”',
        });
        return;
      }

      if (
        response?.data?.message?.includes('User is not found') ||
        response?.data?.message?.includes('User is not active')
      ) {
        setError('email', {
          type: 'manual',
          message: 'Please check your Email!',
        });
        return;
      }

      // Surface the account-lockout / attempts-remaining messages
      // (server-owned copy) inline under the password field, stripping the
      // leading "[code]" prefix the API messages carry.
      const lockoutMessage = response?.data?.message;
      if (
        lockoutMessage &&
        (lockoutMessage.includes('temporarily locked') ||
          lockoutMessage.includes('attempts remaining') ||
          lockoutMessage.includes('attempt remaining'))
      ) {
        setError('password', {
          type: 'manual',
          message: lockoutMessage.replace(/^\[\d+-\d+\]\s*/, ''),
        });
        return;
      }

      displayErrorDetails(error);
    }
  };
  const onSubmit = async (data: UserSubmitForm): Promise<void> => {
    try {
      setSafeLoading(true);

      if (isValidPhoneNumber(data.email)) {
        phoneCaptureRef.current = data.email.replace(/\s+|[()-.]/g, '');
      }

      const response = await login({
        email: normalizeUsername(data.email),
        password: data.password,
        organization_id: config.organization_id,
        ...(config.division_id && { division_id: config.division_id }),
        ...(config.practice_id && { practice_id: config.practice_id }),
      });

      if (response.mfa_method) {
        setShowTwoFactorAuth({ trigger: true, response });
      } else if (response.access_token && response.refresh_token) {
        await triggerLogin(response);
      }
    } catch (error: unknown) {
      endLogin(data, error);
    } finally {
      setSafeLoading(false);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    setError,
    clearErrors,
    getValues,
  } = useForm<UserSubmitForm>({
    mode: 'onChange',
    resolver: yupResolver(validationSchema),
  });

  if (otpModal) return <ConfirmOTP username={credentials.username as string} onConfirmed={onConfirmedOTP} />;
  if (forgotPasswordStep) return renderForgotPasswordModal();
  if (updateEmailStep) return renderUpdateEmailModal();

  const hideModals = (): void => {
    setForgotPasswordStep(0);
    setResetFlag(false);
    setCredentials({ username: '', code: '', new_password: '' });
    navigate('/');
  };

  const closeInviteModal = (): void => {
    hardSignOut();
    setInviteResult(null);
    sessionStorage.removeItem('authSuspend');
    sessionStorage.removeItem('inviteResult');
  };

  const backToDashboard = (): void => {
    try {
      localStorage.setItem('isAuthenticated', JSON.stringify({ isAuthenticated: true }));
    } catch {
      /* noop */
    }
    sessionStorage.removeItem('authSuspend');
    sessionStorage.removeItem('inviteResult');
    navigate('/Patient/dashboard');
    setInviteResult(null);
  };

  const goToMyPlan = (): void => {
    try {
      localStorage.setItem('isAuthenticated', JSON.stringify({ isAuthenticated: true }));
    } catch {
      /* noop */
    }
    sessionStorage.removeItem('authSuspend');
    sessionStorage.removeItem('inviteResult');
    navigate(PLAN_ROUTE);
    setInviteResult(null);
  };

  const renderInviteModal = (): JSX.Element | null => {
    if (!inviteResult) return null;

    const isHasPlan = inviteResult.status === 'HAS_PLAN' || inviteResult.status === 'OWNER_CANNOT_JOIN';
    const invalid = inviteResult.status === 'INVALID_TOKEN';

    const title = isHasPlan
      ? 'It looks like you’re already in a plan'
      : invalid
      ? 'Invite link invalid'
      : 'Invite not available';

    const body = isHasPlan
      ? 'At this time, it’s only possible to be in one plan — so you’ll stay with your current plan.'
      : invalid
      ? 'This invite link is invalid or expired. Please contact the person who shared the link with you for assistance.'
      : 'Looks like this plan already has the maximum number of members. If you still need access, we recommend contacting the person who shared the link with you.';

    return (
      <div
        role="dialog"
        aria-modal="true"
        style={backdropStyle}
        onClick={closeInviteModal}
        onKeyDown={(e) => e.key === 'Escape' && closeInviteModal()}
        tabIndex={-1}
      >
        <div style={modalStyle} onClick={(e) => e.stopPropagation()}>
          <button type="button" aria-label="Close" onClick={closeInviteModal} style={closeBtnStyle}>
            ×
          </button>

          <div style={titleStyle}>{title}</div>
          <div style={descStyle}>{body}</div>

          {isHasPlan ? (
            <>
              <button type="button" onClick={goToMyPlan} style={primaryBtnStyle}>
                Go to My Plan
              </button>
              <button type="button" onClick={closeInviteModal} style={linkBtnStyle}>
                Cancel
              </button>
            </>
          ) : (
            <button type="button" onClick={backToDashboard} style={primaryBtnStyle}>
              Back to Dashboard
            </button>
          )}
        </div>
      </div>
    );
  };
  // Render nothing while checking URL
  if (!urlChecked) {
    return <Loading fullScreen />;
  }
  return (
    <div>
      {renderInviteModal()}
      {showTwoFactorAuth.trigger ? (
        <MultiFactorAuthentication
          loginResponse={showTwoFactorAuth.response!}
          setShowTwoFactorAuth={setShowTwoFactorAuth}
          userCredentials={{
            email: getValues('email')?.toLowerCase(),
            password: getValues('password'),
          }}
          triggerLogin={triggerLogin}
          endLogin={endLogin}
        />
      ) : (
        <>
          <Sidenav isVisibleOnMobile hideDefaultOptions authLoog hideModals={hideModals} />
          <div className={styles.body}>
            <div className={styles.leftSection}>
              <div className={styles.container}>
                <form className={styles.formContainer} onSubmit={handleSubmit(onSubmit)}>
                  <span className={styles.formTitle}>
                    <span className={`${styles.formTitleWelcome} fs-unmask`} data-testid="signin-welcome-back">
                      Welcome back
                    </span>

                    <div className={`${styles.formTitleLink} fs-unmask`} data-testid="signin-title">
                      <span className={styles.txt1}>Don’t have an account yet?</span>
                      <a
                        className={`txt2 ${styles.txt2}`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => {
                          const searchParams = new URLSearchParams(window.location.search);

                          const invite = localStorage.getItem(INVITE_TOKEN_KEY) || searchParams.get('invite');

                          const startCase = searchParams.get('start_case');

                          const params = new URLSearchParams();

                          if (invite) {
                            params.set('invite', invite);
                          }

                          if (startCase) {
                            params.set('start_case', startCase);
                          }

                          const signUpPath = clientCode ? `/${clientCode}/sign-up` : '/sign-up';
                          navigate(`${signUpPath}${params.toString() ? `?${params.toString()}` : ''}`);
                        }}
                        data-testid="signin-title-link"
                      >
                        &nbsp;Sign up
                      </a>
                    </div>
                  </span>

                  <div className={styles.inputWrap}>
                    <TextField
                      {...register('email')}
                      data-testid="signin-email-input"
                      label="Email"
                      required
                      errors={errors.email ? errors : {}}
                      name="email"
                      onChange={(e) => {
                        if (errors.email) clearErrors('email');
                        setValue('email', e.target.value);
                      }}
                      inputClass={`${styles.profileInputClass} fs-exclude`}
                      wrapperClassName={`fs-unmask ${styles.createAccountClass}`}
                    />
                    <div className={`${styles.invalidFeedback} invalid-feedback`}>{errors.email?.message}</div>
                  </div>

                  <div className={styles.inputWrap}>
                    <div className={styles.inputWrapper}>
                      <TextField
                        {...register('password')}
                        data-testid="signin-password-input"
                        label="Password"
                        required
                        type="password"
                        showPasswordToggle
                        name="password"
                        onChange={(e) => {
                          clearErrors('password');
                          const { value } = e.target;
                          setValue('password', value);
                        }}
                        errors={errors.password ? errors : {}}
                        inputClass={`${styles.profileInputClass} fs-exclude`}
                        wrapperClassName={`fs-unmask ${styles.createAccountClass}`}
                      />
                      <div className={`${styles.invalidFeedback} invalid-feedback`}>{errors.password?.message}</div>
                    </div>
                  </div>

                  <div
                    className={`${styles.formCheck} fs-unmask`}
                    style={{ paddingLeft: '0px' }}
                    onClick={() => setForgotPasswordStep(1)}
                    onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && setForgotPasswordStep(1)}
                    role="button"
                    tabIndex={0}
                    data-testid="signin-forgot-password"
                  >
                    Forgot password?
                  </div>

                  <Button
                    type="submit"
                    className={`${loading && styles.inActiveBtn} fs-unmask ${styles.formBtn}`}
                    style={{ borderRadius: '4px', height: '56px', pointerEvents: loading ? 'none' : undefined }}
                    disabled={loading}
                    data-testid="signin-login-button"
                  >
                    Log in
                  </Button>
                  {config.features.passkey && browserSupportsWebAuthn() && (
                    <button
                      type="button"
                      onClick={onPasskeySignIn}
                      className="fs-unmask"
                      style={{ marginTop: 12, width: '100%', height: 56, borderRadius: 4 }}
                    >
                      Sign in with a passkey
                    </button>
                  )}
                </form>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SignIn;

const backdropStyle: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.25)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};

const modalStyle: React.CSSProperties = {
  width: 480,
  maxWidth: '90vw',
  background: '#fff',
  borderRadius: 8,
  padding: '32px 28px 28px',
  position: 'relative',
  boxShadow:
    '0px 22px 40px rgba(16, 24, 40, 0.18), 0px 8px 16px rgba(16, 24, 40, 0.12), 0px 2px 6px rgba(16, 24, 40, 0.08)',
  textAlign: 'center',
};

const closeBtnStyle: React.CSSProperties = {
  position: 'absolute',
  top: 12,
  right: 12,
  width: 32,
  height: 32,
  borderRadius: 16,
  border: 'none',
  background: 'transparent',
  cursor: 'pointer',
  fontSize: 22,
  lineHeight: '22px',
};

const titleStyle: React.CSSProperties = {
  fontSize: 20,
  fontWeight: 700,
  color: '#101828',
  marginBottom: 8,
};

const descStyle: React.CSSProperties = {
  fontSize: 14,
  color: '#475467',
  marginBottom: 20,
  lineHeight: '20px',
};

const primaryBtnStyle: React.CSSProperties = {
  width: '100%',
  height: 44,
  borderRadius: 999,
  border: 'none',
  background: '#10A4E8', // primary brand color
  color: '#fff',
  fontWeight: 600,
  cursor: 'pointer',
  marginTop: 6,
};

const linkBtnStyle: React.CSSProperties = {
  width: '100%',
  height: 44,
  borderRadius: 999,
  border: 'none',
  background: 'transparent',
  color: '#10A4E8',
  fontWeight: 600,
  cursor: 'pointer',
  marginTop: 8,
  textDecoration: 'none',
};
